const riot = require('riot');

riot.tag2('modal-template-edit', '<form class="w420 bg-white p24 rounded-8" ref="modal" onsubmit="{onSubmit}"> <label class="f fbw fm mb16"> <div class="letter-spacing-0_03em bold lh15">テンプレートの{opts.item ? \'編集\' : \'追加\'}</div> <div class="f fm fs20 text-label_medium"><i class="icon-stash_box cursor-pointer mr8" if="{opts.item}" onclick="{onDelete}"></i><i class="icon-close cursor-pointer" onclick="{close}"></i></div> </label> <input class="input w-full focus-primary mb16" ref="title" type="text" placeholder="タスク内容を記入してください" oninput="{_.noop}"> <div class="f fm w-full mb16"> <div class="f fm"> <label class="relative mr16"> <input class="input w158 h36 focus-primary px28 focus-text-label_high" ref="project_select" riot-style="color: {currentProject ? currentProject.getColor() : app.data.project.disabledColor};" riot-value="{currentProject ? currentProject.data.name : \'\'}" placeholder="プロジェクト" onfocus="{onOpenPopupSelect}" onclick="{onOpenPopupSelect}" oninput="{projectPopup ? debounceSearchProjects : onOpenPopupSelect}" onblur="{closeProjectPopup}" onkeydown="{projectPopup.selectionList.onKeyDown}"> <div class="absolute l12 t15 z1 s8 circle mr4" if="{currentProject &amp;&amp; document.activeElement !== refs.project_select}" riot-style="background-color: {currentProject.data.color || app.utils.defaultColor};"></div><i class="absolute l8 t7 z1 icon-project text-label_medium fs16 mr4" if="{!currentProject || document.activeElement === refs.project_select}"></i><i class="icon-close absolute t7 r8 z1 text-label_medium fs16 cursor-pointer" if="{refs.project_select.value}" onclick="{onDeleteText}"></i> </label> </div> <div class="f fm w-full rounded-8 bg-background_primary overflow-hidden focus-primary pl8"><i class="icon-tag text-label_medium fs16 mr4"></i> <div class="fs12 lh15 w-full overflow-hidden" ref="tags" data-is="atom-input-tags" onchange="{_.noop}"></div> </div> </div> <div class="f fbw fm"> <div class="relative f fm border rounded-6 focus-primary"> <div class="absolute r8 t0 b0 f fh h-full"><i class="icon-arrow_down text-label_medium"></i></div> <select class="relative fs12 lh15 py7 pl12 pr30 cursor-pointer" ref="duration"> <option each="{item in app.data.template.duration}" riot-value="{item.duration}">{item.label}</option> </select> </div> <button class="button px34 py6 fs12 lh15 fw4 hover-trigger {checkedHasValue() ? &quot;primary&quot; : &quot;disabled&quot;}" ref="saveButton" disabled="{!checkedHasValue()}">保存</button> </div> </form>', 'modal-template-edit,[data-is="modal-template-edit"]{background-color:rgba(0,0,0,0.5)} modal-template-edit .focus-text-label_high:focus-within,[data-is="modal-template-edit"] .focus-text-label_high:focus-within{color:#2E2E38 !important}', 'class="f fh" spat-animation="push"', function(opts) {
    this.displayProjects = [];
    this.on('mount', async () => {

      var projects = await app.store.collection('projects')

        .fetch();
      projects.sort((a, b) => a.data.name.toLowerCase() < b.data.name.toLowerCase() ? -1 : 1);

      var unselected_project = { id: 'unselect', data: { name:'未設定' }, unselected: true };
      projects.unshift(unselected_project);

      this.projects = projects;
      this.update();

      if (this.opts.item) {
        this.refs.title.value = this.opts.item.data.title;

        if (this.opts.item.relation.project && this.opts.item.relation.project.doc.exists) {
          this.currentProject = this.projects.find(p => p.id === this.opts.item.data.project_ref.id);
        }

        if (this.opts.item.data.tags) {
          this.refs.tags.setValues(opts.item.data.tags);
        }

        this.refs.duration.value = this.opts.item.data.duration || app.data.template.defaultDuration;
      }
      else {
        this.refs.duration.value = app.data.template.defaultDuration;
      }

      this.update();

      this.refs.title.focus();

      this.refs.tags.on('submit', () => {
        if (this.checkedHasValue()) {
          this.submit();
        }
      });
    });

    this.onSubmit = (e) => {
      e.preventDefault();
      this.submit();
    };

    this.submit = () => {

      var project = this.currentProject;

      var data = {
        title: this.refs.title.value,
        project,
        tags: this.refs.tags.getValues(),
        duration: this.refs.duration.value,
      };

      if (this.opts.item) {
        this.trigger('submit', { data });
      }
      else {

        this.trigger('create', { data });
      }
      this.close();
    };

    this.onDeleteText = () => {
      this.refs.project_select.value = '';
      this.update();
    };

    this.onDelete = async () => {
      var result = await spat.modal.confirm('削除しますか？');
      if (!result) return;
      this.trigger('delete');
      this.close();
    };

    this.checkedHasValue = () => {
      return !!this.refs.title.value.trim() || this.currentProject || this.refs.tags.getValues().length;
    };

    this.getSearchProjects = () => {
      if (!this.refs.project_select) return [];

      var projects = this.refs.project_select.value ? this.displayProjects : this.projects;

      projects = projects.filter(p => !p.data.archived);
      return projects;
    };

    this.searchProjects = () => {
      if (!this.projectPopup) return ;
      const value = this.refs.project_select.value;
      const keyword = value.toLowerCase();

      this.displayProjects = this.projects.map(project => {
        const index = project.data.name.toLowerCase().indexOf(keyword);
        return { index, project };
      }).filter(item => item.index >= 0).sort((a, b) => a.index - b.index).map(item => item.project);
      this.update();
      this.projectPopup.setItems();
      this.projectPopup.update();
    };

    this.debounceSearchProjects = _.debounce(() => {
      this.searchProjects();
    }, 64);

    this.onOpenPopupSelect = async (e) => {
      if (this.projectPopup) return;

      this.refs.project_select.select();
      this.projectPopup = spat.popup.open('popup-select', {
        element: e.currentTarget,
        align:{ x:'left', y:'top' },
        position: 'bottom',
        offsetTop: 48,
        opener: this.root,
        dismissible: false,
        opts: {
          options: () => { return this.getSearchProjects(); },
          kind: 'project',
          search: e.currentTarget,
        },
      }).on('select',({ option: project }) => {
        if (project && project.id === 'new') {
          this.close();
          spat.router.push('/projects/new');
          return ;
        }
        this.currentProject = project.unselected ? null : project;
        this.refs.project_select.value = project.unselected ?  '' : project.data.name;
        this.update();
      }).on('close', () => {
        this.projectPopup = null;
        this.update();
      });
      this.searchProjects();
    };

    this.closeProjectPopup = () => {

      if (!this.projectPopup) return;

      if (this.refs.project_select) {
        this.projectPopup.selectCurrent();
      }
      else {
        this.projectPopup.close();
      }
    };
});